import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import callApi from '../helpers/apiCaller';
import config from '../common/config';
import Cookies from 'universal-cookie';

const initialState = {
  isLogin: false,
  username: '',
  name: '',
  user: [],
  error: null,
};

var cookies = new Cookies();
  var accessToken = cookies.get('access_token');
  if(accessToken == undefined){
    accessToken = window.localStorage.getItem("AccessToken");
  }
  var header = { authorization: accessToken }


export const checkLogin = createAsyncThunk('user/checklogin', async () => {
    try {
        // get user
        const url = config.getRootURL() + '/gd/v3/user_infos';
        await callApi(url, 'GET', {}, header).then(response => {
        if (response == false) {
            config.hideLoader();
            return {isLogin:false};
        }
        if(response.data.data.user != undefined)
        {
            return response.data.data.user;
        }
        });
    } catch (error) {
        return {isLogin:false};
    }
  });
  

const UserStore = createSlice({
    name: 'user',
    initialState,
    reducers: {
        // addLikeItem(state, action) {
        // const { id } = action.payload;
        // },
    },
   extraReducers: {
    [checkLogin.pending]: (state, action) => {
        state.isLogin = true;
    },
    // [checkLogin.fulfilled]: (state, action) => {
    //     state.isLogin = false;
    //     state.user = action.payload;
    // },
    // [checkLogin.rejected]: (state, action) => {
    //     state.isLogin = false;
    //     state.error = action.error;
    // },
    //  builder.addCase(checkLogin.fulfilled, (state, action) => {
    //      
    //    state.isLogin = action.payload.isLogin;
    //  })
   },
});

export default UserStore.reducer
//export const selectAllItemId = (state) => state.itemsLiked

